import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaBullseye, FaEye, FaHeart, FaUsers, FaTrophy, FaHandshake } from 'react-icons/fa';
import './About.css';

const About = () => {
  const { t } = useTranslation();

  const values = [
    {
      icon: <FaBullseye />,
      title: t('about.mission.title'),
      description: t('about.mission.description')
    },
    {
      icon: <FaEye />,
      title: t('about.vision.title'),
      description: t('about.vision.description')
    },
    {
      icon: <FaHeart />,
      title: t('about.values.title'),
      description: t('about.values.description')
    }
  ];

  const stats = [
    { icon: <FaUsers />, number: '500+', label: t('about.stats.partners') },
    { icon: <FaTrophy />, number: '10+', label: t('about.stats.experience') },
    { icon: <FaHandshake />, number: '99%', label: t('about.stats.satisfaction') }
  ];

  return (
    <div className="about-page">
      {/* Header Section */}
      <section className="about-header">
        <div className="about-header-overlay"></div>
        <div className="container">
          <h1>{t('about.title')}</h1>
          <p>{t('about.subtitle')}</p>
        </div>
      </section>

      {/* Main Content */}
      <section className="about-content">
        <div className="container">
          <div className="about-intro">
            <div className="about-text">
              <h2>{t('about.title')}</h2>
              <p>{t('about.description')}</p>
            </div>
            <div className="about-image">
              <img src="/PasaLebensmittelLogo.jpg" alt="Paşa Lebensmittel" />
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            {stats.map((stat, index) => (
              <div className="stat-card" key={index}>
                <div className="stat-icon">{stat.icon}</div>
                <div className="stat-number">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section">
        <div className="container">
          <h2 className="section-title">{t('about.values.title')}</h2>
          <div className="values-grid">
            {values.map((value, index) => (
              <div className="value-card" key={index}>
                <div className="value-icon">{value.icon}</div>
                <h3>{value.title}</h3>
                <p>{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="team-section">
        <div className="container">
          <h2 className="section-title">{t('about.whyChoose.title')}</h2>
          <div className="features-list">
            <div className="feature-item">
              <div className="feature-number">01</div>
              <h3>{t('about.whyChoose.quality.title')}</h3>
              <p>{t('about.whyChoose.quality.description')}</p>
            </div>
            <div className="feature-item">
              <div className="feature-number">02</div>
              <h3>{t('about.whyChoose.delivery.title')}</h3>
              <p>{t('about.whyChoose.delivery.description')}</p>
            </div>
            <div className="feature-item">
              <div className="feature-number">03</div>
              <h3>{t('about.whyChoose.pricing.title')}</h3>
              <p>{t('about.whyChoose.pricing.description')}</p>
            </div>
            <div className="feature-item">
              <div className="feature-number">04</div>
              <h3>{t('about.whyChoose.support.title')}</h3>
              <p>{t('about.whyChoose.support.description')}</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;

